



































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class PopupDeleteShift extends Vue {
  @Prop({ default: true }) readonly clickToClose!: boolean;
  @Prop(String) readonly name!: string;
  @Prop(Boolean) readonly disabledBtSubmit!: boolean;
  @Prop(Boolean) readonly disabledBtCancel!: boolean;
  @Prop({ default: 250 }) readonly height!: number;
  @Prop({ default: 420 }) readonly width!: number;
  @Prop({ default: false }) readonly showHeader!: boolean;
  @Prop({ default: true }) readonly btnClose!: boolean;

  deleteOption: 'current' | 'series' = 'current';

  submitConfirmDeleteSeries() {
    const isApplyToSeries = this.deleteOption === 'series';
    this.$emit('submit', isApplyToSeries);
  }
}
